/* GoGo Solar — one footer for the whole site.
   Column headings and links mirror the old Wix site so the footer reads the
   same on the homepage, product pages, collections and content pages.
   Any footer the theme renders is hidden rather than removed.

   The wordmark is set in type rather than an image while the new logo is
   being made — swap an <img> back in when the file arrives.

   Companies House confirmed the change to GOGO SOLAR LTD, so the disclosure
   line now carries that name on its own. The number is unchanged — a change
   of name does not create a new company.

   POSITIONING: the footer must sit after <main>, and it did not always.
   The homepage is a React app, so on a slow load this script ran before
   React had created <main>, fell back to appending to <body>, and the
   footer ended up above the whole site. place() now runs on every observer
   pass and moves the footer back below <main> whenever it is not there,
   rather than building once and hoping. */
(function () {
  var STYLE_ID = "bsl-footer-style-v3";
  var GOLD = "#F5A800";
  var HOFFUM =
    "https://cdn.shopify.com/s/files/1/1011/9715/2638/files/Hoffum_20Logo.webp?v=1785104513";

  var COLS = [
    {
      h: "Shop",
      links: [
        ["Shop All", "/collections/all"],
        ["Sale", "/collections/sale"],
        ["Best Sellers", "/collections/best-sellers"],
        ["Street Lights", "/collections/street-lights"],
        ["New Arrivals", "/collections/latest-arrivals"],
        ["Solar Lights", "/collections/solar-lights"],
        ["Fields & Farms", "/collections/fields-farms"]
      ]
    },
    {
      h: "Company",
      links: [
        ["About", "/pages/about-us"],
        ["Blog", "/blogs/news"],
        ["Contact", "/pages/contact"],
        ["Projects", "/pages/projects"],
        ["Reviews", "/pages/reviews"]
      ]
    },
    {
      h: "Support",
      links: [
        ["Shipping", "/pages/shipping-policy"],
        ["Refunds & Returns", "/pages/refunds-returns"],
        ["Store Policies", "/policies/terms-of-service"],
        ["Privacy Policy", "/pages/privacy-policy"]
      ]
    }
  ];

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = [
      "footer:not(#bsl-footer){display:none !important}",
      "#bsl-footer{background:#171A15;color:#EEF0EB;padding:4rem 1.5rem 2rem;" +
        "font-family:Inter,system-ui,sans-serif;display:block}",
      ".bsl-f-top{max-width:1200px;margin:0 auto 3rem;display:grid;" +
        "grid-template-columns:2fr 1fr 1fr 1fr;gap:3rem}",
      "@media(max-width:900px){.bsl-f-top{grid-template-columns:1fr 1fr;gap:2.2rem}}",
      "@media(max-width:560px){.bsl-f-top{grid-template-columns:1fr}}",
      ".bsl-f-word{font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;font-weight:900;" +
        "font-size:1.7rem;letter-spacing:-.025em;color:#EEF0EB;margin:0 0 1.1rem;line-height:1}",
      ".bsl-f-word span{color:" + GOLD + "}",
      ".bsl-f-brand p.blurb{font-size:.85rem;line-height:1.75;color:rgba(238,240,235,.6);max-width:300px;margin:0 0 1.6rem}",
      ".bsl-f-col h4{font-size:.72rem;font-weight:700;letter-spacing:.16em;text-transform:uppercase;" +
        "color:#fff;margin:0 0 1.1rem;font-family:Satoshi,ui-sans-serif,system-ui,sans-serif}",
      ".bsl-f-col ul{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:.65rem}",
      ".bsl-f-col a{color:rgba(238,240,235,.6);font-size:.85rem;text-decoration:none;transition:color .2s}",
      ".bsl-f-col a:hover{color:" + GOLD + "}",

      ".bsl-partner{display:flex;align-items:center;gap:.7rem}",
      ".bsl-partner-label{font-size:.74rem;color:rgba(238,240,235,.5);white-space:nowrap}",
      ".bsl-partner img{height:22px;width:auto;opacity:.75;transition:opacity .2s;filter:brightness(1.4)}",
      ".bsl-partner img:hover{opacity:1}",

      ".bsl-f-bottom{max-width:1200px;margin:0 auto;border-top:1px solid rgba(245,168,0,.16);" +
        "padding-top:1.5rem;display:flex;justify-content:center !important;align-items:center;" +
        "flex-wrap:wrap;gap:1rem;text-align:center;flex-direction:column}",
      ".bsl-f-bottom p{font-size:.76rem;color:rgba(238,240,235,.5);margin:0}",
      ".bsl-f-badges{display:flex;align-items:center;gap:1.2rem;flex-wrap:wrap;justify-content:center}",
      ".bsl-f-badges span{font-size:.74rem;color:rgba(238,240,235,.6);display:flex;align-items:center;gap:.35rem}",
      ".bsl-f-badges span::before{content:'✓';color:" + GOLD + ";font-weight:700}",
      "@media(min-width:900px){.bsl-f-bottom{flex-direction:row;gap:2rem}}"
    ].join("");
    document.head.appendChild(s);
  }

  function html() {
    var cols = COLS.map(function (c) {
      return (
        '<div class="bsl-f-col"><h4>' + c.h + "</h4><ul>" +
        c.links.map(function (l) {
          return '<li><a href="' + l[1] + '">' + l[0] + "</a></li>";
        }).join("") +
        "</ul></div>"
      );
    }).join("");

    return (
      '<div class="bsl-f-top">' +
        '<div class="bsl-f-brand">' +
          '<p class="bsl-f-word">GoGo<span>Solar</span></p>' +
          '<p class="blurb">We believe reliable light is a right, not a luxury. Empowering homes, ' +
          "businesses and communities with clean solar energy — no cables, no trenching, " +
          "no electricity bills.</p>" +
          '<div class="bsl-partner">' +
            '<span class="bsl-partner-label">Proud partner of</span>' +
            '<a href="https://www.hoffum.com/" target="_blank" rel="noopener">' +
              '<img src="' + HOFFUM + '" alt="Hoffum">' +
            "</a>" +
          "</div>" +
        "</div>" + cols +
      "</div>" +
      '<div class="bsl-f-bottom">' +
        "<p>© 2026 GoGo Solar Ltd · Company No. 16765359 · " +
          "Registered in England &amp; Wales</p>" +
        '<div class="bsl-f-badges">' +
          "<span>1 year warranty</span><span>Free UK delivery</span><span>30-day returns</span>" +
        "</div>" +
      "</div>"
    );
  }

  /* put the footer where it belongs, every pass, not just when it is built */
  function place(f) {
    var main = document.querySelector("main");
    if (main && main.parentElement) {
      if (f.previousElementSibling !== main) {
        main.parentElement.insertBefore(f, main.nextSibling);
      }
      return;
    }
    /* no <main> yet — React has not rendered. Park it at the end of body so
       it is never above the site, and move it properly on a later pass. */
    if (document.body && document.body.lastElementChild !== f) {
      document.body.appendChild(f);
    }
  }

  function build() {
    styles();

    var f = document.getElementById("bsl-footer");
    if (!f) {
      f = document.createElement("footer");
      f.id = "bsl-footer";
      f.innerHTML = html();
    }
    place(f);
  }

  new MutationObserver(build).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") build();
  else document.addEventListener("DOMContentLoaded", build);
  window.addEventListener("load", build);
})();
